import api from '../../api/rideInformation';
import { handleGuiVersionOutdated } from '@/common/guiVersionHandler';
import { withDesignSections } from '@/utils/rideDesigns';

/**
 * Saving how the trip page looks: the design to show and any design's own
 * settings (ride.presentation_settings, one section per design id). For every
 * design's editor -- the poster's is the first (PosterEditor) -- so none of it
 * is about one design.
 *
 * It goes through update_ride_information_api, the same route as the ride
 * settings form, because the route is partial: only the fields sent change,
 * and of presentation_settings only the sections sent.
 */

const actions = {
  // design: the design to show. sections: { <design id>: its settings, or
  // null to put it back to automatic }; the designs left out are kept.
  // Owner-only on the server. On success the page's ride header is updated in
  // place, so the page redraws without refetching the ride. Resolves to
  // whether it was saved.
  async saveRidePresentation({ rootState, commit, dispatch }, { rideId, design, sections = {} }) {
    const { apptoken } = rootState.appauth;
    const payload = { presentation_design: design, presentation_settings: sections };
    let code;
    try {
      const response = await api.updateRideInformation(apptoken, rideId, payload);
      code = response.data && response.data.ServerMassageCode;
    } catch (error) {
      // A user who is not the ride owner gets a 500 with no body.
      console.warn('saveRidePresentation failed:', error);
      code = null;
    }
    if (code !== 'secsses') {
      if (code === 'gui_version_outdated') {
        handleGuiVersionOutdated({ dispatch, rideInformationId: rideId });
      }
      return false;
    }
    const header = rootState.ride.rideHeader;
    if (header && header.ride) {
      commit('setRideHeader', Object.assign({}, header, {
        ride: Object.assign({}, header.ride, {
          presentation_design: design,
          presentation_settings: withDesignSections(header.ride, sections),
        }),
      }));
    }
    return true;
  },
};

export default {
  actions,
};
